import './App.css';

import categoryList from './components/Categories';
import { NavbarC } from './components/Navbar';
import Home from './pages/Home';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import ScrollToTopOnNavigation from './components/ScrollToTopOnNavigation';
import { ContactUs } from './pages/ContactUs';
import OurServices from './pages/OurServices';
import AboutUs from './pages/AboutUs';
import Blogs from './pages/Blogs';
import { Footer } from './components/Footer';
import blogList from './components/BlogData';
import BlogItem from './pages/blog/BlogItem';
import CategoryBlogs from './pages/category/CategoryBlogs';
import PageNotFound from './pages/PageNotFound';
import LiferaySolutions from './pages/service/LiferaySolutions';
import ManagedServices from './pages/service/ManagedServices';
import Testing from './pages/service/Testing';
import IndustrialSolutions from './pages/service/IndustrialSolutions';
import AIMLDevelopment from './pages/service/AIMLDevelopment';
import CloudSolutions from './pages/service/CloudSolutions';
import EmbeddedSystems from './pages/service/EmbeddedSystems';
import Teams from './pages/Teams';
import CaseStudies from './pages/CaseStudies';
import WomenInAI from './pages/WomenInAI';
import ASEANJudiciaryPortal from './pages/ASEANJudiciaryPortal';
import BancaAigisCaseStudy from './pages/BancaAigisCaseStudy';
import EuropeanGCCMigration from './pages/EuropeanGCCMigration';
import ZariGathaCaseStudy from './pages/ZariGathaCaseStudy';

function App() {

  return (
    <>
    <Router>
    <ScrollToTopOnNavigation />
      <NavbarC />
      <Routes>
        <Route exact path="/" element={<Home/>}  />
        <Route exact path="/home" element={<Home/>}  />
        <Route exact path="/service" element={<OurServices/>} />
        <Route exact path="/case-studies" element={<CaseStudies/>} />
        <Route exact path="/service/liferay-consultation-and-solutions" element={<LiferaySolutions />}  />
        <Route exact path="/service/managed-services" element={<ManagedServices />}  />
        <Route exact path="/service/testing" element={<Testing />}  />
        <Route exact path="/service/industrial-solutions" element={<IndustrialSolutions />}  />
        <Route exact path="/service/ai-ml-development" element={<AIMLDevelopment />}  />
        <Route exact path="/service/cloud-solutions" element={<CloudSolutions />}  />
        <Route exact path="/service/embedded-systems" element={<EmbeddedSystems />}  />
        <Route exact path="/teams" element={<Teams />}  />
        {blogList.map((blog, index) => (
        <Route  key={`blog-${index}`} exact path={"/blog/"+blog.title.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase()} element={<BlogItem blog={blog}/>} />
        ))}
        {Object.values(categoryList).map((category, index) => (
        <Route  key={`category-${index}`} exact path={"/category/"+category.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase()} element={<CategoryBlogs categoryname={category}/>} />
        ))}
        <Route exact path="/about-us" element={<AboutUs/>} />
        <Route exact path="/contact-us" element={<ContactUs/>} />
        <Route exact path="/blogs" element={<Blogs/>} />
        <Route exact path="/about-us" element={<AboutUs/>} />
        <Route exact path="/case-studies/women-in-ai" element={<WomenInAI/>} />
        <Route exact path="/case-studies/asean-judiciary-portal" element={<ASEANJudiciaryPortal/>} />
        <Route exact path="/case-studies/banca-aigis" element={<BancaAigisCaseStudy/>} />
        <Route exact path="/case-studies/european-gcc-migration" element={<EuropeanGCCMigration/>} />
        <Route exact path="/case-studies/zari-gatha" element={<ZariGathaCaseStudy/>} />
        <Route exact path="*" element={<PageNotFound/>} />
      </Routes>
      <Footer/>
      {/* <Footer title="News App" firsttab="Home"/> */}
      </Router>
    </>
  );
}

export default App;
